define(['./util/is-function.js', './util/is-array.js',
    './util/is-plain-object.js'
], /** @lends morningstar.asterix.Extend */ function(isFunction, isArray, isPlainObject) {

    /**
     * Packaged javascript object extends from jQuery ($.extend) with the notable exception
     * that $.extend({}) does not extend the morningstar.asterix or morningstar namespace.
     *
     * @class
     * @param {*|boolean} [target|deep copy] [object to extend or flag for deep copy]
     * @param {*} [target] [target if deep copy specified]
     * @param {...*} [sources] [sources to extend target with, may be multiple]
     * @return {object} extended object
     * @author dcolli1
     */
    'use strict';

    function extend() {
        var src, copyIsArray, copy, name, options, clone,
            target = arguments[0] || {},
            i = 1,
            length = arguments.length,
            deep = false;

        if (length === 1) {
            return;
        }

        // Handle a deep copy situation
        if (typeof target === 'boolean') {
            deep = target;
            target = arguments[1] || {};
            // skip the boolean and the target
            i = 2;
        }

        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== 'object' && !isFunction(target)) {
            target = {};
        }

        for (; i < length; i++) {
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) {
                // extend the base object
                for (name in options) {
                    src = target[name];
                    copy = options[name];

                    // Prevent never-ending loop
                    if (target === copy) {
                        continue;
                    }

                    // Recurse if we're merging plain objects or arrays
                    if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                        if (copyIsArray) {
                            copyIsArray = false;
                            clone = src && isArray(src) ? src : [];
                        } else {
                            clone = src && isPlainObject(src) ? src : {};
                        }

                        // Never move original objects, clone them
                        target[name] = extend(deep, clone, copy);

                        // Don't bring in undefined values
                    } else if (copy !== undefined) {
                        target[name] = copy;
                    }
                }
            }
        }

        // Return the modified object
        return target;
    }

    return extend;
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/extend.js
 ** module id = 3
 ** module chunks = 0
 **/